import { CheckCircleIcon } from '@interstate/components/Icons/CheckCircleIcon';
import { ExclamationCircleIcon } from '@interstate/components/Icons/ExclamationCircleIcon';
import { ExclamationTriangleIcon } from '@interstate/components/Icons/ExclamationTriangleIcon';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

interface IconByLevelProps {
    level?: string;
}

export const IconByLevel = ({ level }: IconByLevelProps) => {
    const theme = useInterstateTheme();
    switch (level) {
        case 'alert':
            return (
                <ExclamationCircleIcon fontSize="1rem" color={theme.tokens.BaseColorRed500} data-testid="compliance-alert-icon" />
            );
        case 'verified':
            return (
                <CheckCircleIcon fontSize="1rem" color={theme.tokens.BaseColorGreen500} data-testid="compliance-verified-icon" />
            );
        case 'warning':
            return (
                <ExclamationTriangleIcon
                    fontSize="1rem"
                    color={theme.tokens.BaseColorGold500}
                    data-testid="compliance-warning-icon"
                />
            );
        default:
            return null;
    }
};
